import { render, staticRenderFns } from "./socializationModal.vue?vue&type=template&id=46784aaa&scoped=true"
import script from "./socializationModal.vue?vue&type=script&lang=js"
export * from "./socializationModal.vue?vue&type=script&lang=js"
import style0 from "./socializationModal.vue?vue&type=style&index=0&id=46784aaa&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46784aaa",
  null
  
)

export default component.exports